import { CompanyDTO } from './company.model';
/**
 * Modello utilizzato per la form di creazione azienda e assegnazione licenza.
 * Questo modello è stato creato da Alessandro Di Salvatore SOLO per la demo ma andrebbe eliminato
 * e tutti i punti in cui, successivamente, è stato usato per errore vanno rifattorizzati usando i modelli che sono
 * stati aggiunti cioè CompanyCommercialProductDTO o CommercialProductDTO o LicenceAssignmentDTO
 */
export class CommercialProductAssignmentDTO {
  public ID: number;
  public Code: string;
  public Title: string;
  public Credits: number;
  public CommercialProductCategoryEnum: CommercialProductCategoryEnum;
  public StartDate: Date;
  public EndDate: Date;
  public InvoiceQuantity: number;
  public PurchaseQuantity: number;
  public IsSelected: boolean;
  public Limitation: ProductLimitationDTO;
}

export class CommercialProductDTO {
  public ID: number;
  public Code: string;
  public Title: string;
  public Credits: number;
  public CommercialProductCategoryEnum: CommercialProductCategoryEnum;
  public FK_ShareXLS: number;
  public StartDate: Date;
  public EndDate: Date;
  public InvoiceQuantity: number;
  public PeriodEnum: CommercialProductPeriodEnum;
  public PeriodValue: number;
  public UpdateDate: Date;
  public Deleted: boolean;
}

export class CompanyCommercialProductDTO {
  public ID: number;
  public CommercialProduct: CommercialProductDTO;
  public LicensesAvailable: number;
  public MyNamirialPurchaseEmail: string;
  public InUse: boolean;
  public IsAdmin: boolean;
  public InUseFrom: Date;
  public InUseTo: Date;
  public ProductType: number;
  public QuantityPurchase: number;
  public QuantitySent: number;
}

export enum CommercialProductCategoryEnum {
  EFT = 1,
  PLUS = 2,
}

export enum CommercialProductPeriodEnum {
  DAY = 1,
  MONTH = 2,
  YEAR = 3
}

export class LicenceAssignmentDTO {
  public FK_CompanyFrom: number;
  public FK_UserFrom: string;
  public FK_CompanyTo: number;
  public FK_CommercialProduct: number;
  public Quantity: number;
  public MyNamirialPurchaseEmail: string;
  public Limitation: ProductLimitationDTO;
}

export class ProductLimitationDTO {
  public InUseFrom: Date;
  public InUseTo: Date;
}

export class CompanyAssignLicenceDTO {
  public Company: CompanyDTO;
  public LicenceAssignment: LicenceAssignmentDTO;
}

export class CompanyPayContextDTO {
  public ID: number;  
  public Context: string;
  public FK_Company: number;
  public ServicePay: number;  
  public DaysLink: number;
}


export enum ContextPayEnum {
  CREDIT_CARD_SCT = 0  
}